import 'bootstrap';

import AOS from 'aos'
import 'flickity';
import 'flickity-as-nav-for'

import GDPR from "./components/GDPR";
import Typed from "./components/typed";
import Navbar from "./components/navbar";
import Isotope from "./components/isotope";
import Jarallax from "./components/jarallax";
import PostLoader from "./components/post-loader";
import Gtag from "./components/gtag";

window.addEventListener('load', function () {

    Typed.run();
    Navbar.run();
    Isotope.run();
    Jarallax.run();
    PostLoader.run();
    Gtag.run();

    AOS.init();
    GDPR.run()

});

console.log("MimP - Menu in my Pocket // Powered by Softedge and Hoptimalt - made in belgium.");
